<!-- HTML5 for large and normal desktops -->
<div *ngIf='screenWidth > 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div *ngIf='search_section === "all"'>
      <div class="alert alert-danger" *ngIf='serviceError?.length > 0'>{{serviceError}}</div>
      <div class="alert alert-danger" *ngIf='apiCheck === 0'>No matching results</div>
      <div>
        <div>
          <div *ngIf="bulletinApiDataObject['Service Bulletins']?.length > 0">
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header">Service Bulletins</div>
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin pointer" (click)='addDocToHistory("sib", bulletin?.id)'
                *ngFor="let bulletin of bulletinApiDataObject['Service Bulletins'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                
                <a href="?linemake={{selectedBranch}}#/bulletin/{{bulletin.bulletinDisplayId}}?type=sib&page=1">
                
                  <div class="col-lg-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                    <div class="col-lg-1 bmw-no-gutter"></div>
                    <div class="col-lg-2 bmw-no-gutter">
                      <i class="material-icons dp48" style="color:#b2aa8e;font-size:20px;">fiber_new</i>
                    </div>
                    <div class="col-lg-6 bmw-no-gutter bmw-align-text-right" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'>
                    </div>
                  </div>
                  
                  <div class="col-lg-5 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.description | highlightSearch : searchKey'>
                  </div>
                  <div class="col-lg-3 bmw-no-gutter">
                    <span *ngFor="let seriesVar of bulletin.series" class="col-lg-4 bmw-lg-results-content-service-bulletins-padding">
                        <i [innerHTML]='seriesVar?.seriesName | highlightSearch : searchKey'></i>
                    </span>
                  </div>
                  <div class="col-lg-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'>
                  </div>
                </a>
              </div>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("sib")' class="pointer bmw-results-content-see-more-anchor" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>See more Service Bulletins</a>
            </div>
          </div>

         

          <div *ngIf="bulletinApiDataObject['Parts Bulletins']?.length > 0">
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Parts Bulletins</div>
            <div class="row bmw-no-gutter">
              <a target="_blank" [href]='"parts_bulletin/"+bulletin.attachments[0]?.fileName' class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin pointer"
                (click)='addDocToHistory("pbs", bulletin?.id)' *ngFor="let bulletin of bulletinApiDataObject['Parts Bulletins'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-lg-1 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                  <div class="col-lg-1 bmw-no-gutter"></div>
                  <div class="col-lg-2 bmw-no-gutter">
                    <i class="material-icons dp48" style="color:#b2aa8e;font-size:20px;">fiber_new</i>
                  </div>
                  <div class="col-lg-9 bmw-no-gutter bmw-align-text-right" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'>

                  </div>
                </div>
                <div class="col-lg-1 bmw-no-gutter"></div>
                <div class="col-lg-6 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.description | highlightSearch : searchKey'>
                </div>
                <div class="col-lg-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                </div>
                <div class="col-lg-1 bmw-no-gutter"></div>
                <div class="col-lg-1 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'>
                </div>
              </a>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("pbs")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Parts Bulletins</a>
            </div>
          </div>
          <div *ngIf="bulletinApiDataObject['Technical Training Manuals']?.length > 0">
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Technical Training Manuals</div>
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter pointer" (click)='addDocToHistory("tm", manual?.id)' *ngFor="let manual of bulletinApiDataObject['Technical Training Manuals'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <a [href]='"mount/tech_training_manual/"+manual.documentFileName' target="_blank" class="col-lg-8 bmw-lg-results-content-tech-training">
                  <div class="col-lg-4" [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
                  <div class="col-lg-6" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                  <div class="col-lg-2 bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                  </div>
                </a>
              </div>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("tm")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Technical Training Manuals</a>
            </div>
          </div>

          <div *ngIf='bulletinApiDataObject["Equipment Manuals"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Equipment Manuals</div>
            <div class="row bmw-no-gutter">
              <a [href]="(manual?.documentFileName!=null && manual?.documentFileName?.startsWith('http')) ? manual?.documentFileName : 'http://'+ manual?.documentFileName" target="_blank" class="row bmw-no-gutter pointer" (click)='addDocToHistory("bpm", manual?.id)'
                *ngFor="let manual of bulletinApiDataObject['Equipment Manuals'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-lg-8 bmw-lg-results-content-body-paint" *ngIf="manual?.attachmentType === 'Link'">
                  <div class="col-lg-4" [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
                  <div class="col-lg-6" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                  <div class="col-lg-2 bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                      link
                    </i>
                  </div>
                </div>
              </a>
              <a [href]='"mount/equipment_manual/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter pointer" (click)='addDocToHistory("bpm", manual?.id)'
                *ngFor="let manual of bulletinApiDataObject['Equipment Manuals'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-lg-8 bmw-lg-results-content-body-paint" *ngIf="techDoc?.attachmentType === 'File'">
                  <div class="col-lg-4" [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
                  <div class="col-lg-6" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                  <div class="col-lg-2 bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                      {{ manual.documentFileType === "pdf" ? "picture_as_pdf" : manual.documentFileType === "zip" ? "file_download" : manual.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                    </i>
                  </div>
                </div>
              </a>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("tm")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Equipment Manuals</a>
            </div>
          </div>

          <div *ngIf='bulletinApiDataObject["Body & Paint Manuals"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Body & Paint Manuals</div>
            <div class="row bmw-no-gutter">
              <a [href]='"mount/body_and_paint_manual/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter pointer" (click)='addDocToHistory("bpm", manual?.id)'
                *ngFor="let manual of bulletinApiDataObject['Body & Paint Manuals'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-lg-8 bmw-lg-results-content-body-paint">
                  <div class="col-lg-4" [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
                  <div class="col-lg-6" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                  <div class="col-lg-2 bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                  </div>
                </div>
              </a>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("tm")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Body & Paint Manuals</a>
            </div>
          </div>

          <div *ngIf='bulletinApiDataObject["Onboard Diagnostic (OBD)"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Onboard Diagnostic (OBD)</div>
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin pointer" (click)='addDocToHistory("obd", manual?.id)'
                *ngFor='let manual of bulletinApiDataObject["Onboard Diagnostic (OBD)"] | filterResults: filter | sortResults: sortBy | limitResults: limit'>
                <a [href]='"mount/obd/"+manual?.documentFileName' target="_blank">
                  <div class="col-lg-3 bmw-no-gutter">
                    <div class="col-lg-2 bmw-no-gutter bmw-align-text-left" *ngFor='let engine of manual.engines' [innerHTML]='engine.engineName | highlightSearch : searchKey'>
                    </div>
                  </div>
                  <div class="col-lg-5" [innerHTML]='manual.engineFamily | highlightSearch : searchKey'></div>
                  <div class="col-lg-2">
                    <div class="bmw-align-text-left" style="margin-right:3px;float:left" *ngFor='let model of manual.series' [innerHTML]='model.seriesName | highlightSearch: searchKey'></div>
                  </div>
                  <div class="col-lg-2 bmw-aligh-text-right" [innerHTML]='manual.releaseDate | date: dateFormat'></div>
                </a>
              </div>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("obd")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Onboard Diagnostic (OBD)</a>
            </div>
          </div>

          <div *ngIf='bulletinApiDataObject["Tools Report"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Tools Report</div>
            <div class="row bmw-no-gutter">
              <div [routerLink]='["/report-detail", report?.id]' class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin pointer"
                (click)='addDocToHistory("tools", report?.id)' *ngFor="let report of bulletinApiDataObject['Tools Report'] | filterResults: filter | sortResults: sortBy | limitResults: limit">

                <a href="?linemake={{selectedBranch}}#/report-detail/{{report?.id}}?page=1">
                
                  <div class="col-lg-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.orderPartNumberId | highlightSearch: searchKey'>
                  </div>
                  <div class="col-lg-1 bmw-no-gutter"></div>
                  <div class="col-lg-6 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.description | highlightSearch : searchKey'>
                  </div>
                  <div class="col-lg-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                    <!-- <div *ngFor="let model of report.series">
                      <div class="bmw-lg-results-content-service-bulletins-model bmw-align-text-left" style="margin-right:3px;float:left" [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
                    </div> -->
                  </div>
                  <div class="col-lg-1 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.bulletinId | highlightSearch : searchKey'>
                  </div>
                
                </a>

              </div>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("te")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Tools Report</a>
            </div>
          </div>

          <div *ngIf='bulletinApiDataObject["Technical Documentation"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Technical Documentation</div>
            <div class="row bmw-no-gutter">
              <a [href]="(techDoc?.documentFileName!=null && techDoc?.documentFileName?.startsWith('http')) ? techDoc?.documentFileName : 'http://'+ techDoc?.documentFileName" target="_blank" class="row bmw-no-gutter pointer" (click)='addDocToHistory("td", techDoc?.id)'
                *ngFor="let techDoc of bulletinApiDataObject['Technical Documentation'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-lg-8 bmw-lg-results-content-tech-doc" *ngIf="techDoc?.attachmentType === 'Link'">
                  <div class="col-lg-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
                  </div>
                  <div class="col-lg-2 bmw-no-gutter bmw-align-text-right">
                    <i class="material-icons dp48 pointer" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                      link</i>
                  </div>
                </div>
              </a>
              <a [href]="'mount/technical_documentation/'+techDoc?.documentFileName" target="_blank" class="row bmw-no-gutter pointer" (click)='addDocToHistory("td", techDoc?.id)'
                *ngFor="let techDoc of bulletinApiDataObject['Technical Documentation'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-lg-8 bmw-lg-results-content-tech-doc" *ngIf="techDoc?.attachmentType === 'File'">
                  <div class="col-lg-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
                  </div>
                  <div class="col-lg-2 bmw-no-gutter bmw-align-text-right">
                    <i class="material-icons dp48 pointer" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                      {{ techDoc.documentFileType === "pdf" ? "picture_as_pdf" : techDoc.documentFileType === "zip" ? "file_download" : techDoc.documentFileType === "xlsx" ? "insert_drive_file" : "" }}</i>
                  </div>
                </div>
              </a>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("td")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Technical Documentation</a>
            </div>
          </div>

          <div *ngIf='bulletinApiDataObject["Top Links"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Top Links</div>
            <div class="row bmw-no-gutter">
              <div class="alert alert-danger" *ngIf="!bulletinApiData">{{serviceError}}</div>
              <div class="row bmw-no-gutter " *ngFor="let manual of bulletinApiDataObject['Top Links'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-lg-8 bmw-lg-results-content-tech-training">
                  <a *ngIf="manual?.attachmentType === 'Link'" [href]="(manual?.documentFileName!=null && manual?.documentFileName?.startsWith('http')) ? manual?.documentFileName : 'http://'+ manual?.documentFileName" target="_blank">
                    <div class="col-lg-7" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                    <div class="col-lg-3"></div>
                    <div class="col-lg-2 bmw-align-text-right">
                      <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>link</i>
                    </div>
                  </a>
                  <a *ngIf="manual?.attachmentType === 'File'" [href]='"mount/faq_and_top_link/"+manual.documentFileName' target="_blank">
                    <div class="col-lg-7" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                    <div class="col-lg-3"></div>
                    <div class="col-lg-2 bmw-align-text-right">
                      <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                        {{ manual.documentFileType === "pdf" ? "picture_as_pdf" : manual.documentFileType === "zip" ? "file_download" : manual.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                      </i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("faq")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Top Links</a>
            </div>
          </div>

          <div *ngIf='bulletinApiDataObject["FAQs"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">FAQs</div>
            <div class="row bmw-no-gutter">
              <div class="alert alert-danger" *ngIf="!bulletinApiData">{{serviceError}}</div>
              <div class="row bmw-no-gutter " *ngFor="let manual of bulletinApiDataObject['FAQs'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-lg-8 bmw-lg-results-content-tech-training">
                  <a *ngIf="manual?.attachmentType === 'Link'" [href]="(manual?.documentFileName!=null && manual?.documentFileName?.startsWith('http')) ? manual?.documentFileName : 'http://'+ manual?.documentFileName" target="_blank">
                    <div class="col-lg-7" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                    <div class="col-lg-3"></div>
                    <div class="col-lg-2 bmw-align-text-right">
                      <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>link</i>
                    </div>
                  </a>
                  <a *ngIf="manual?.attachmentType === 'File'" [href]='"mount/faq_and_top_link/"+manual.documentFileName' target="_blank">
                    <div class="col-lg-7" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                    <div class="col-lg-3"></div>
                    <div class="col-lg-2 bmw-align-text-right">
                      <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                        {{ manual.documentFileType === "pdf" ? "picture_as_pdf" : manual.documentFileType === "zip" ? "file_download" : manual.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                      </i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("faq")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more FAQs</a>
            </div>
          </div>

        </div>

      </div>
    </div>
    <div *ngIf='search_section==="sib"'>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Service Bulletins</div>
        <div class="alert alert-danger" *ngIf='serviceError?.length > 0'>{{serviceError}}</div>
        <!-- <div class="alert alert-danger" *ngIf='!bulletinApiData && bulletinApiData?.length === 0'>No matching records found</div> -->
        <div class="row bmw-no-gutter" *ngIf='bulletinApiData?.length > 0'>
            <div class="row bmw-no-gutter" *ngIf='bulletinApiData?.length > 0'>
                <div class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin pointer" (click)='addDocToHistory("sib", bulletin?.id)'
                  *ngFor="let bulletin of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit" >
                  
                  <a href="?linemake={{selectedBranch}}#/bulletin/{{bulletin.bulletinDisplayId}}?type=sib&page=1">

                    <div class="col-lg-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                      <div class="col-lg-1 bmw-no-gutter"></div>
                      <div class="col-lg-2 bmw-no-gutter">
                        <i class="material-icons dp48" style="color:#b2aa8e;font-size:20px;">fiber_new</i>
                      </div>
                      <div class="col-lg-6 bmw-no-gutter bmw-align-text-right" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'>
                      </div>
                    </div>
                    
                    <div class="col-lg-5 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.description | highlightSearch : searchKey'>
                    </div>
                    <div class="col-lg-3 bmw-no-gutter">
                      <span *ngFor="let seriesVar of bulletin.series" class="col-lg-4 bmw-lg-results-content-service-bulletins-padding">
                          <span [innerHTML]='seriesVar?.seriesName | highlightSearch : searchKey'></span>
                      </span>
                    </div>
                    <div class="col-lg-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'>
                    </div>
                  
                  </a>

                </div>
              </div>
        </div>
      </div>
    </div>
    
    <div *ngIf='search_section==="pbs"'>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Parts Bulletins</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <div class="alert alert-warning" *ngIf='!bulletinApiData && bulletinApiData?.length === 0'>No matching records found</div>
          <div *ngIf='bulletinApiData?.length > 0'>
            <a target="_blank" [href]='"parts_bulletin/"+bulletin?.bulletinFile?.fileName' class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin pointer"
              (click)='addDocToHistory("pbs", bulletin?.id)' *ngFor="let bulletin of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <div class="col-lg-1 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                <div class="col-lg-1 bmw-no-gutter"></div>
                <div class="col-lg-2 bmw-no-gutter">
                  <i class="material-icons dp48" style="color:#b2aa8e;font-size:20px;">fiber_new</i>
                </div>
                <div class="col-lg-9 bmw-no-gutter bmw-align-text-right" [innerHTML]='bulletin?.bulletinDisplayNumber | highlightSearch : searchKey'>

                </div>
              </div>
              <div class="col-lg-1 bmw-no-gutter"></div>
              <div class="col-lg-6 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin?.description | highlightSearch : searchKey'>
              </div>
              <div class="col-lg-2 ">
                <!-- <div *ngFor="let model of bulletin.series">
                <div class="col-lg-2 bmw-lg-results-content-service-bulletins-model bmw-align-text-left" [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
              </div> -->
              </div>
              <div class="col-lg-1 bmw-no-gutter"></div>
              <div class="col-lg-1 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin?.releaseDate | date: dateFormat | highlightSearch : searchKey'>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="td"'>
      <div class="bmw-lg-results-content-tech_documentation">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Technical Documentation</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <div class="alert alert-warning" *ngIf='!bulletinApiData && bulletinApiData?.length === 0'>No matching records found</div>
          <a target="_blank" [href]="(techDoc?.documentFileName!=null && techDoc?.documentFileName?.startsWith('http')) ? techDoc?.documentFileName : 'http://'+ techDoc?.documentFileName"  class="row bmw-no-gutter pointer" (click)='addDocToHistory("em", manual?.id)'
              *ngFor="let techDoc of bulletinApiData | sortResults: sortBy | limitResults: limit">
              <div class="col-lg-8 bmw-lg-results-content-tech-doc" *ngIf="techDoc?.attachmentType === 'Link'">
                <div class="col-lg-10" [innerHTML]='techDoc.documentTitle | highlightSearch:searchKey'></div>
                <div class="col-lg-2 bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>link</i>
              </div>
            </div>
          </a>
          <a target="_blank" [href]="'mount/technical_documentation/'+techDoc?.documentFileName" class="row bmw-no-gutter pointer" (click)='addDocToHistory("em", manual?.id)'
              *ngFor="let techDoc of bulletinApiData | sortResults: sortBy | limitResults: limit">
              <div class="col-lg-8 bmw-lg-results-content-tech-doc" *ngIf="techDoc?.attachmentType === 'File'">
                <div class="col-lg-10" [innerHTML]='techDoc.documentTitle | highlightSearch:searchKey'></div>
                <div class="col-lg-2 bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                    {{ techDoc.documentFileType === "pdf" ? "picture_as_pdf" : techDoc.documentFileType === "zip" ? "file_download" : techDoc.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                  </i>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="tm"'>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Technical Training Manuals</div>
        <div class="row bmw-no-gutter">
          <!-- <div class="alert alert-danger" *ngIf="!bulletinApiData">{{serviceError}}</div> -->
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <!-- <div class="alert alert-warning" *ngIf='!bulletinApiData && bulletinApiData?.length === 0'>No matching records found</div> -->
          <a [href]='"mount/tech_training_manual/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter pointer" (click)='addDocToHistory("tm", manual?.id)'
            *ngFor="let manual of bulletinApiData | sortResults: sortBy | limitResults: limit">
            <div class="col-lg-8 bmw-lg-results-content-tech-training">
              <div class="col-lg-4" [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
              <div class="col-lg-6" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-lg-2 bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="bmw-lg-section-seperator"></div>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Body & Paint Manuals</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceCoError?.length > 0">{{serviceCoError}}</div>
          <!-- <div class="alert alert-danger" *ngIf="!bulletinCoSectionApiData?.length">No matching records</div> -->
          <a [href]='"mount/body_and_paint_manual/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter pointer" (click)='addDocToHistory("bpm", manual?.id)'
            *ngFor="let manual of bulletinCoSectionApiData | sortResults: sortBy | limitResults: limit">
            <div class="col-lg-8 bmw-lg-results-content-body-paint">
              <div class="col-lg-4" [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
              <div class="col-lg-6" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-lg-2 bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="faq"'>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header">Top Links</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <!-- <div class="alert alert-warning" *ngIf='!bulletinApiData && bulletinApiData?.length === 0'>No matching records found</div> -->
          <a [href]="(manual?.documentFileName!=null && manual?.documentFileName?.startsWith('http')) ? manual?.documentFileName : 'http://'+ manual?.documentFileName" target="_blank" *ngFor="let manual of bulletinApiData | sortResults: sortBy | limitResults: limit">
            <div class="col-lg-8 bmw-lg-results-content-tech-training" *ngIf="manual?.attachmentType === 'Link'">
              <div class="col-lg-7 pointer" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-lg-3"></div>
              <div class="col-lg-2 bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                  link
                </i>
              </div>
            </div>
          </a>
          <a [href]='"mount/faq_and_top_link/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter" *ngFor="let manual of bulletinApiData | sortResults: sortBy | limitResults: limit">
            <div class="col-lg-8 bmw-lg-results-content-tech-training" *ngIf="manual?.attachmentType === 'File'">
              <div class="col-lg-7 pointer" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-lg-3"></div>
              <div class="col-lg-2 bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                  {{ manual.documentFileType === "pdf" ? "picture_as_pdf" : manual.documentFileType === "zip" ? "file_download" : manual.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                </i>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="bmw-lg-section-seperator"></div>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">FAQ</div>
        <div class="row bmw-no-gutter">
          <!-- <div class="alert alert-danger" *ngIf="!bulletinCoSectionApiData">{{serviceError}}</div> -->
          <div class="alert alert-danger" *ngIf="serviceCoError?.length > 0">{{serviceCoError}}</div>
          <!-- <div class="alert alert-danger" *ngIf="!bulletinApiData?.length">No matching records</div> -->
          <a [href]="(manual?.documentFileName!=null && manual?.documentFileName?.startsWith('http')) ? manual?.documentFileName : 'http://'+ manual?.documentFileName" target="_blank" class="row bmw-no-gutter" *ngFor="let manual of bulletinCoSectionApiData | sortResults: sortBy | limitResults: limit">
            <div class="col-lg-8 bmw-lg-results-content-body-paint" *ngIf="manual?.attachmentType === 'Link'">
              <div class="col-lg-7 pointer" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-lg-3"></div>
              <div class="col-lg-2 bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>link</i>
              </div>
            </div>
          </a>
          <a [href]='"mount/faq_and_top_link/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter" *ngFor="let manual of bulletinCoSectionApiData | sortResults: sortBy | limitResults: limit">
            <div class="col-lg-8 bmw-lg-results-content-body-paint" *ngIf="manual?.attachmentType === 'File'">
              <div class="col-lg-7 pointer" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-lg-3"></div>
              <div class="col-lg-2 bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                  {{ manual.documentFileType === "pdf" ? "picture_as_pdf" : manual.documentFileType === "zip" ? "file_download" : manual.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                </i>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="obd"'>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">OBD</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <div class="alert alert-warning" *ngIf='!bulletinApiData && bulletinApiData?.length === 0'>No matching records found</div>
          <div *ngFor="let manual of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit" class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin pointer"
            (click)='addDocToHistory("obd", manual?.id)'>
            <a [href]='"mount/obd/"+manual?.documentFileName' target="_blank">
              <div class="col-lg-3 bmw-no-gutter">
                <div class="col-lg-2 bmw-no-gutter bmw-align-text-left" *ngFor='let engine of manual.engines' [innerHTML]='engine.engineName | highlightSearch : searchKey'>
                </div>
              </div>
              <div class="col-lg-5" [innerHTML]='manual.engineFamily | highlightSearch : searchKey'></div>
              <div class="col-lg-2">
              </div>
              <div class="col-lg-2 bmw-aligh-text-right" [innerHTML]='manual.releaseDate | date: dateFormat'></div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="te"'>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Equipment Manuals</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <div *ngIf="bulletinApiData?.length">
            <a [href]="(manual?.documentFileName!=null && manual?.documentFileName?.startsWith('http')) ? manual?.documentFileName : 'http://'+ manual?.documentFileName" target="_blank" class="row bmw-no-gutter pointer" (click)='addDocToHistory("em", manual?.id)'
              *ngFor="let manual of bulletinApiData | sortResults: sortBy | limitResults: limit">
              <div class="col-lg-8 bmw-lg-results-content-tech-training" *ngIf="manual?.attachmentType === 'Link'">
                <div class="col-lg-10" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                <div class="col-lg-2 bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>link</i>
                </div>
              </div>
            </a>
            <a [href]='"mount/equipment_manual/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter pointer" (click)='addDocToHistory("em", manual?.id)'
              *ngFor="let manual of bulletinApiData | sortResults: sortBy | limitResults: limit">
              <div class="col-lg-8 bmw-lg-results-content-tech-training" *ngIf="manual?.attachmentType === 'File'">
                <div class="col-lg-10" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                <div class="col-lg-2 bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                    {{ manual.documentFileType === "pdf" ? "picture_as_pdf" : manual.documentFileType === "zip" ? "file_download" : manual.documentFileType === "xlsx" ? "insert_drive_file" : "" }}
                  </i>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="bmw-lg-section-seperator"></div>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Tools</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceCoError?.length > 0">{{serviceCoError}}</div>
          <div *ngIf="bulletinCoSectionApiData?.length">
            <div [routerLink]='["/report-detail", report?.id]' class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin pointer"
              (click)='addDocToHistory("tools", report?.id)' *ngFor="let report of bulletinCoSectionApiData | sortResults: sortBy | limitResults: limit">
              <div class="col-lg-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.orderPartNumberId | highlightSearch: searchKey'>
              </div>
              <div class="col-lg-1 bmw-no-gutter"></div>
              <div class="col-lg-6 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.description | highlightSearch : searchKey'>
              </div>
              <div class="col-lg-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                <div *ngFor="let model of report.series">
                  <div class="col-lg-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-model bmw-align-text-left" style="margin-right:3px"
                    [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
                </div>
              </div>
              <div class="col-lg-1 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.bulletinId | highlightSearch : searchKey'>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- HTML5 for Ipad Pro and small desktops -->

<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>

  <div (window:orientationchange)="screenRotate($event)">
    <div *ngIf='search_section === "all"'>
      <div class="alert alert-danger" *ngIf='apiCheck === 0'>No matching results</div>
      <div>
        <div>
          <div *ngIf="bulletinApiDataObject['Service Bulletins']?.length > 0">
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Service Bulletins</div>
            <div class="row bmw-no-gutter">
              <div class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin" [routerLink]="['/bulletin', bulletin.bulletinDisplayId]"
                [queryParams]='{type: "sib"}' *ngFor="let bulletin of bulletinApiDataObject['Service Bulletins'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-md-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                  <div class="col-md-2 bmw-no-gutter">
                    <i class="material-icons dp48" style="color:#b2aa8e;font-size:20px;">fiber_new</i>
                  </div>
                  <div class="col-md-10 bmw-no-gutter " [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'>

                  </div>
                </div>
                <div class="col-md-6 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.description | highlightSearch : searchKey'>
                </div>
                <div class="col-md-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                  <div *ngFor="let model of bulletin.series">
                    <div class="bmw-lg-results-content-service-bulletins-model bmw-align-text-left" style="margin-right:3px;float:left" [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
                  </div>
                </div>
                <div class="col-md-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding bmw-align-text-right" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'>
                </div>
              </div>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a [routerLink]="['/results', 'sib']" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Service Bulletins</a>
            </div>
          </div>


         


          <div *ngIf='bulletinApiDataObject["Parts Bulletins"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Parts Bulletins</div>
            <div class="row bmw-no-gutter">
              <a target="_blank" [href]='"parts_bulletin/"+bulletin.attachments[0]?.fileName' class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin"
                *ngFor="let bulletin of bulletinApiDataObject['Parts Bulletins'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-md-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                  <div class="col-md-2 bmw-no-gutter">
                    <i class="material-icons dp48" style="color:#b2aa8e;font-size:20px;">fiber_new</i>
                  </div>
                  <div class="col-md-10 bmw-no-gutter" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'>

                  </div>
                </div>
                <div class="col-md-6 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.description | highlightSearch : searchKey'>
                </div>
                <div class="col-md-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                  <div *ngFor="let model of bulletin.series">
                    <div class="bmw-lg-results-content-service-bulletins-model bmw-align-text-left" style="margin-right:3px;float:left" [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
                  </div>
                </div>
                <div class="col-md-2 bmw-align-text-right bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'>
                </div>
              </a>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("pbs")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Parts Bulletins</a>
            </div>
          </div>
          <div *ngIf='bulletinApiDataObject["Technical Training Manuals"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Technical Training Manuals</div>
            <div class="row bmw-no-gutter">
              <a [href]='"tech_training_manuals/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter " *ngFor="let manual of bulletinApiDataObject['Technical Training Manuals']  | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-md-8 bmw-lg-results-content-tech-training">
                  <div class="col-md-4" [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
                  <div class="col-md-6" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                  <div class="col-md-2 bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                  </div>
                </div>
              </a>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("tm")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Technical Training Manuals</a>
            </div>
          </div>

          <div *ngIf='bulletinApiDataObject["Body & Paint Manuals"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Body & Paint Manuals</div>
            <div class="row bmw-no-gutter">
              <a [href]='"body_and_paint/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter" *ngFor="let manual of bulletinApiDataObject['Body & Paint Manuals'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-md-8 bmw-lg-results-content-body-paint">
                  <div class="col-md-4" [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
                  <div class="col-md-6" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                  <div class="col-md-2 bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                  </div>
                </div>
              </a>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("tm")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Body & Paint Manuals</a>
            </div>
          </div>
          <div *ngIf='bulletinApiDataObject["Onboard Diagnostic (OBD)"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Onboard Diagnostic (OBD)</div>
            <div class="row bmw-no-gutter">
              <a [href]='"mount/obd/"+manual?.documentFileName' target="_blank" class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin" *ngFor="let manual of bulletinApiDataObject['Onboard Diagnostic (OBD)'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-md-3 bmw-no-gutter">
                  <div style="margin-right:3px;float:left" *ngFor='let engine of manual.engines' [innerHTML]='engine.engineName | highlightSearch : searchKey'>
                  </div>
                </div>
                <div class="col-md-5" [innerHTML]='manual.engineFamily | highlightSearch : searchKey'></div>
                <div class="col-md-2">
                  <div class="bmw-align-text-left" style="margin-right:3px;float:left" *ngFor='let model of manual.series' [innerHTML]='model.seriesName | highlightSearch: searchKey'></div>
                </div>
                <div class="col-md-2 bmw-aligh-text-right" [innerHTML]='manual.releaseDate | date: dateFormat'></div>
              </a>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("obd")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Onboard Diagnostic (OBD)</a>
            </div>
          </div>
          <div *ngIf='bulletinApiDataObject["Equipment Manuals"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Equipment Manuals</div>
            <div class="row bmw-no-gutter">
              <a [href]='"equipmentManual/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter " *ngFor="let manual of bulletinApiDataObject['Equipment Manuals'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-md-8 bmw-lg-results-content-tech-training">
                  <div class="col-md-10" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                  <div class="col-md-2 bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                  </div>
                </div>
              </a>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("te")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Equipment Manuals</a>
            </div>
          </div>


          <div *ngIf='bulletinApiDataObject["Tools Report"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Tools Report</div>
            <div class="row bmw-no-gutter">
              <div [routerLink]='["/report-detail", report?.id]' class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin"
                *ngFor="let report of bulletinApiDataObject['Tools Report'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-md-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.orderPartNumberId | highlightSearch: searchKey'>
                </div>
                <div class="col-md-1 bmw-no-gutter"></div>
                <div class="col-md-6 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.description | highlightSearch : searchKey'>
                </div>
                <div class="col-md-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                  <div *ngFor="let model of report.series">
                    <div class="bmw-lg-results-content-service-bulletins-model bmw-align-text-left" style="margin-right:3px;float:left" [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
                  </div>
                </div>
                <div class="col-md-1 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.bulletinId | highlightSearch : searchKey'>
                </div>
              </div>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("te")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Tools Report</a>
            </div>
          </div>


          <div *ngIf='bulletinApiDataObject["Technical Documentation"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Technical Documentation</div>
            <div class="row bmw-no-gutter">
              <a [href]='"tech_documents/"+techDoc.documentFileName' target="_blank" style="cursor:pointer" class="row bmw-no-gutter "
                *ngFor="let techDoc of bulletinApiDataObject['Technical Documentation'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-md-8 bmw-lg-results-content-tech-doc">
                  <div class="col-md-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
                  </div>
                  <div class="col-md-2 bmw-no-gutter bmw-align-text-right">
                    <a [href]='"tech_documents/"+techDoc.documentFileName' target="_blank" style="cursor:pointer">
                      <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                    </a>
                  </div>
                </div>
              </a>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("td")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Technical Documentation</a>
            </div>
          </div>
          <div *ngIf='bulletinApiDataObject["Top Links"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Top Links</div>
            <div class="row bmw-no-gutter">
              <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
              <div class="row bmw-no-gutter " *ngFor="let manual of bulletinApiDataObject['Top Links'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-md-8 bmw-lg-results-content-tech-training">
                  <a [href]='manual.documentFileName' target="_blank">
                    <div class="col-md-7" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                    <div class="col-md-3"></div>
                    <div class="col-md-2 bmw-align-text-right">
                      <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("faq")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Top Links</a>
            </div>
          </div>

          <div *ngIf='bulletinApiDataObject["FAQs"]?.length > 0'>
            <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">FAQs</div>
            <div class="row bmw-no-gutter">
              <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
              <div class="row bmw-no-gutter " *ngFor="let manual of bulletinApiDataObject['FAQs'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
                <div class="col-md-8 bmw-lg-results-content-tech-training">
                  <a [href]='manual.documentFileName' target="_blank">
                    <div class="col-md-7" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                    <div class="col-md-3"></div>
                    <div class="col-md-2 bmw-align-text-right">
                      <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="row bmw-no-gutter bmw-results-content-see-more-row">
              <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
              <a (click)='navigateToSection("faq")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more FAQs</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="sib"'>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Service Bulletins</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <div class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin" [routerLink]="['/bulletin', bulletin.bulletinDisplayId]"
            [queryParams]='{type: "sib"}' *ngFor="let bulletin of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-md-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
              <div class="col-md-2 bmw-no-gutter">
                <i class="material-icons dp48" style="color:#b2aa8e;font-size:20px;">fiber_new</i>
              </div>
              <div class="col-md-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'>

              </div>
            </div>
            <div class="col-md-5 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.description | highlightSearch : searchKey'>
            </div>
            <div class="col-md-2 bmw-no-gutter">
              <div *ngFor="let model of bulletin.series">
                <div class="col-md-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-model bmw-align-text-left" style="margin-right:5px"
                  [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
              </div>
            </div>
            <div class="col-md-3 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" style="padding-left:9%" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'>
            </div>
          </div>
        </div>
      </div>
    </div>
    >
    <div *ngIf='search_section==="pbs"'>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Parts Bulletins</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a target="_blank" [href]='"parts_bulletin/"+bulletin.attachments[0]?.fileName' class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin"
            *ngFor="let bulletin of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-md-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
              <div class="col-md-2 bmw-no-gutter">
                <i class="material-icons dp48" style="color:#b2aa8e;font-size:20px;">fiber_new</i>
              </div>
              <div class="col-md-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'>

              </div>
            </div>
            <div class="col-md-7 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.description | highlightSearch : searchKey'>
            </div>
            <div class="col-md-3 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" style="padding-left:9%" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="td"'>
      <div class="bmw-lg-results-content-tech_documentation">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Technical Documentation</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a [href]='"tech_documents/"+techDoc.documentFileName' target="_blank" style="cursor:pointer" class="row bmw-no-gutter "
            *ngFor="let techDoc of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-md-8 bmw-lg-results-content-tech-doc">
              <div class="col-md-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
              </div>
              <div class="col-md-2 bmw-no-gutter bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="tm"'>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Technical Training Manuals</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a [href]='"tech_training_manuals/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter " *ngFor="let manual of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-md-8 bmw-lg-results-content-tech-training">
              <div class="col-md-4" [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
              <div class="col-md-6" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-md-2 bmw-align-text-right">
                <a [href]='"tech_training_manuals/"+manual.documentFileName' target="_blank">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                </a>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="bmw-lg-section-seperator"></div>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Body & Paint Manuals</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceCoError?.length > 0">{{serviceCoError}}</div>
          <div class="row bmw-no-gutter" *ngFor="let manual of bulletinCoSectionApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-md-8 bmw-lg-results-content-body-paint">
              <div class="col-md-4" [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
              <div class="col-md-6" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-md-2 bmw-align-text-right">
                <a [href]='manual.documentFileName' target="_blank">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="obd"'>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">OBD</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a [href]='"mount/obd/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin"
            *ngFor="let manual of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-md-3 bmw-no-gutter">
              <div class="bmw-align-text-left" style="margin-right:3px;float:left" *ngFor='let engine of manual.engines' [innerHTML]='engine.engineName | highlightSearch : searchKey'>
              </div>
            </div>
            <div class="col-md-5" [innerHTML]='manual.engineFamily | highlightSearch : searchKey'></div>
            <div class="col-md-2">
              <div class="bmw-align-text-left" style="margin-right:3px;float:left" *ngFor='let model of manual.series' [innerHTML]='model.seriesName | highlightSearch: searchKey'></div>
            </div>
            <div class="col-md-2 bmw-aligh-text-right" [innerHTML]='manual.releaseDate | date: dateFormat'></div>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="te"'>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Equipment Manuals</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a [href]='"equipmentManual/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter " *ngFor="let manual of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-md-8 bmw-lg-results-content-tech-training">
              <div class="col-md-10" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-md-2 bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="bmw-lg-section-seperator"></div>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Tools</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceCoError?.length > 0">{{serviceCoError}}</div>
          <div [routerLink]='["/report-detail", report?.id]' class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin"
            *ngFor="let report of bulletinCoSectionApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-md-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.orderPartNumberId | highlightSearch: searchKey'>
            </div>
            <div class="col-md-1 bmw-no-gutter"></div>
            <div class="col-md-6 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.description | highlightSearch : searchKey'>
            </div>
            <div class="col-md-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
              <div *ngFor="let model of report.series">
                <div class="bmw-lg-results-content-service-bulletins-model bmw-align-text-left" style="margin-right:3px;float:left" [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
              </div>
            </div>
            <div class="col-md-1 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.bulletinId | highlightSearch : searchKey'>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="faq"'>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header">Top Links</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a [href]='"faq_top_links/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter " *ngFor="let manual of bulletinApiData | sortResults: sortBy | limitResults: limit">
            <div class="col-md-8 bmw-lg-results-content-tech-training">
              <div class="col-md-7 pointer" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-md-3"></div>
              <div class="col-md-2 bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="bmw-lg-section-seperator"></div>
      <div class="bmw-lg-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">FAQ</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceCoError?.length > 0">{{serviceCoError}}</div>
          <a [href]='"faq_top_links/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter" *ngFor="let manual of bulletinCoSectionApiData | sortResults: sortBy | limitResults: limit">
            <div class="col-md-8 bmw-lg-results-content-body-paint">
              <div class="col-md-7 pointer" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-md-3"></div>
              <div class="col-md-2 bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- HTML5 for tablet -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>

  <div (window:orientationchange)="screenRotate($event)">
    <div *ngIf='search_section === "all"' class="bmw-sm-results-content-service-bulletins" style="padding-top:15px">
      <div class="alert alert-danger" *ngIf='apiCheck === 0'>No matching results</div>

      <div>
        <div *ngIf='bulletinApiDataObject["Service Bulletins"]?.length > 0'>
          <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Service Bulletins</div>
          <div class="row bmw-no-gutter">
            <div class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin" [routerLink]="['/bulletin', bulletin.bulletinDisplayId]"
              [queryParams]='{type: "sib"}' *ngFor="let bulletin of bulletinApiDataObject['Service Bulletins'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <div class="col-sm-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                <div class="col-sm-2 bmw-no-gutter">
                  <i class="material-icons dp48" style="color:#b2aa8e;font-size:20px;">fiber_new</i>
                </div>
                <div class="col-sm-10 bmw-no-gutter" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'>

                </div>
              </div>
              <div class="col-sm-6 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.description | highlightSearch : searchKey'>
              </div>
              <div class="col-sm-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                <div *ngFor="let model of bulletin.series">
                  <div class="bmw-lg-results-content-service-bulletins-model bmw-align-text-left" style="margin-right:3px;float:left" [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
                </div>
              </div>
              <div class="col-sm-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding bmw-align-text-right" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'>
              </div>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a [routerLink]="['/results', 'sib']" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Service Bulletins"</a>
          </div>
        </div>
        <div *ngIf='bulletinApiDataObject["Parts Bulletins"]?.length > 0'>
          <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Parts Bulletins</div>
          <div class="row bmw-no-gutter">
            <div class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin" *ngFor="let bulletin of bulletinApiDataObject['Parts Bulletins'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a target="_blank" [href]='"parts_bulletin/"+bulletin.attachments[0]?.fileName'>
                <div class="col-sm-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                  <div class="col-sm-2 bmw-no-gutter">
                    <i class="material-icons dp48" style="color:#b2aa8e;font-size:20px;">fiber_new</i>
                  </div>
                  <div class="col-sm-10 bmw-no-gutter" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'>

                  </div>
                </div>
                <div class="col-sm-6 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='bulletin.description | highlightSearch : searchKey'>
                </div>
                <div class="col-sm-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                  <div *ngFor="let model of bulletin.series">
                    <div class="bmw-lg-results-content-service-bulletins-model bmw-align-text-left" style="margin-right:3px;float:left" [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
                  </div>
                </div>
                <div class="col-sm-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding bmw-align-text-right" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("pbs")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Parts Bulletins</a>
          </div>
        </div>
        <div *ngIf='bulletinApiDataObject["Technical Training Manuals"]?.length > 0'>
          <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Technical Training Manuals</div>
          <div class="row bmw-no-gutter">
            <div class="row bmw-no-gutter " *ngFor="let manual of bulletinApiDataObject['Technical Training Manuals']  | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a [href]='"tech_training_manuals/"+manual.documentFileName' target="_blank">
                <div class="bmw-lg-results-content-tech-training">
                  <div class="col-sm-4" [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
                  <div class="col-sm-6" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                  <div class="col-sm-2 bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("tm")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Technical Training Manuals</a>
          </div>
        </div>

        <div *ngIf='bulletinApiDataObject["Body & Paint Manuals"]?.length > 0'>
          <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Body & Paint Manuals</div>
          <div class="row bmw-no-gutter">
            <div class="row bmw-no-gutter" *ngFor="let manual of bulletinApiDataObject['Body & Paint Manuals'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a [href]='"body_and_paint/"+manual.documentFileName' target="_blank">
                <div class="bmw-lg-results-content-body-paint">
                  <div class="col-sm-4" [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
                  <div class="col-sm-6" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                  <div class="col-sm-2 bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("tm")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Body & Paint Manuals</a>
          </div>
        </div>
        <div *ngIf='bulletinApiDataObject["Onboard Diagnostic (OBD)"]?.length > 0'>
          <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Onboard Diagnostic (OBD)</div>
          <div class="row bmw-no-gutter">
            <div class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin" *ngFor="let manual of bulletinApiDataObject['Onboard Diagnostic (OBD)'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a [href]='"mount/obd/"+manual.documentFileName' target="_blank">
                <div class="col-sm-3 bmw-no-gutter">
                  <div class="col-sm-3 bmw-no-gutter bmw-align-text-left" *ngFor='let engine of manual.engines' [innerHTML]='engine.engineName | highlightSearch : searchKey'>
                  </div>
                </div>
                <div class="col-sm-5" [innerHTML]='manual.engineFamily | highlightSearch : searchKey'></div>
                <div class="col-sm-2">
                  <div class="bmw-align-text-left" style="margin-right:3px;float:left" *ngFor='let model of manual.series' [innerHTML]='model.seriesName | highlightSearch: searchKey'></div>
                </div>
                <div class="col-sm-2 bmw-aligh-text-right" [innerHTML]='manual.releaseDate | date: dateFormat'></div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("obd")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Onboard Diagnostic (OBD)</a>
          </div>
        </div>


        <div *ngIf='bulletinApiDataObject["Equipment Manuals"]?.length > 0'>
          <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Equipment Manuals</div>
          <div class="row bmw-no-gutter">
            <div class="row bmw-no-gutter " *ngFor="let manual of bulletinApiDataObject['Equipment Manuals'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a [href]='"equipmentManual/"+manual.documentFileName' target="_blank">
                <div class="col-sm-8 bmw-lg-results-content-tech-training">
                  <div class="col-sm-10" [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                  <div class="col-sm-2 bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("te")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Equipment Manuals</a>
          </div>
        </div>


        <div *ngIf='bulletinApiDataObject["Tools Report"]?.length > 0'>
          <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Tools Report</div>
          <div class="row bmw-no-gutter">
            <div [routerLink]='["/report-detail", report?.id]' class="row bmw-no-gutter bmw-lg-results-content-service-bulletins-bulletin"
              *ngFor="let report of bulletinApiDataObject['Tools Report'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <div class="col-sm-2 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.orderPartNumberId | highlightSearch: searchKey'>
              </div>
              <div class="col-sm-1 bmw-no-gutter"></div>
              <div class="col-sm-6 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.description | highlightSearch : searchKey'>
              </div>
              <div class="col-sm-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
                <div *ngFor="let model of report.series">
                  <div class="bmw-lg-results-content-service-bulletins-model bmw-align-text-left" style="margin-right:3px;float:left" [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
                </div>
              </div>
              <div class="col-sm-1 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.bulletinId | highlightSearch : searchKey'>
              </div>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("te")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Tools Report</a>
          </div>
        </div>


        <div *ngIf='bulletinApiDataObject["Technical Documentation"]?.length > 0'>
          <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Technical Documentation</div>
          <div class="row bmw-no-gutter">
            <div class="row bmw-no-gutter " *ngFor="let techDoc of bulletinApiDataObject['Technical Documentation'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a [href]='"tech_training_manuals/"+techDoc.documentFileName' target="_blank">
                <div class="col-sm-8 bmw-lg-results-content-tech-doc">
                  <div class="col-sm-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
                  </div>
                  <div class="col-sm-2 bmw-no-gutter bmw-align-text-right">
                    <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("td")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Technical Documentation</a>
          </div>
        </div>

        <div *ngIf='bulletinApiDataObject["Top Links"]?.length > 0'>
          <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">Top Links</div>
          <div class="row bmw-no-gutter">
            <a [href]='"faq_top_links/"+techDoc.documentFileName' target="_blank" class="row bmw-no-gutter " *ngFor="let techDoc of bulletinApiDataObject['Top Links'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <div class="col-sm-8 bmw-lg-results-content-tech-doc">
                <div class="col-sm-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
                </div>
                <div class="col-sm-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                </div>
              </div>
            </a>
          </div>
          <div class="row bmw-no-gutter bmw-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("faq")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Top Links</a>
          </div>
        </div>

        <div *ngIf='bulletinApiDataObject["FAQs"]?.length > 0'>
          <div class="row bmw-no-gutter bmw-lg-results-content-section-header ">FAQs</div>
          <div class="row bmw-no-gutter">
            <a [href]='"faq_top_links/"+techDoc.documentFileName' target="_blank" class="row bmw-no-gutter " *ngFor="let techDoc of bulletinApiDataObject['FAQs'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <div class="col-sm-8 bmw-lg-results-content-tech-doc">
                <div class="col-sm-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
                </div>
                <div class="col-sm-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                </div>
              </div>
            </a>
          </div>
          <div class="row bmw-no-gutter bmw-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("faq")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more FAQs</a>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="search_section==='sib'">
      <div class="bmw-sm-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-sm-results-content-service-bulletins-header ">Service Bulletins</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <div class="row bmw-no-gutter bmw-md-results-content-service-bulletins-bulletin" [routerLink]="['/bulletin', bulletin.bulletinDisplayId]"
            [queryParams]='{type: "sib"}' *ngFor="let bulletin of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-sm-2 bmw-no-gutter bmw-no-gutter bmw-md-results-content-service-bulletins-padding">
              <div class="col-sm-2 bmw-no-gutter">
                <i class="material-icons dp48" style="color:#b2aa8e;font-size:20px;">fiber_new</i>
              </div>
              <div class="col-sm-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'>
              </div>
            </div>
            <div class="col-sm-6 bmw-no-gutter bmw-md-results-content-service-bulletins-padding" [innerHTML]='bulletin.description | highlightSearch : searchKey'>
            </div>
            <div class="col-sm-2 bmw-no-gutter">
              <div *ngFor="let model of bulletin.series">
                <div class="bmw-md-results-content-service-bulletins-model bmw-align-text-left" style="margin-right:3px;float:left" [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
              </div>
            </div>
            <div class="col-sm-2 bmw-no-gutter bmw-md-results-content-service-bulletins-padding bmw-align-text-right" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="search_section==='pbs'">
      <div class="bmw-sm-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-sm-results-content-service-bulletins-header ">Parts Bulletins</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a target="_blank" [href]='"parts_bulletin/"+bulletin.attachments[0]?.fileName' class="row bmw-no-gutter bmw-md-results-content-service-bulletins-bulletin"
            *ngFor="let bulletin of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-sm-2 bmw-no-gutter bmw-no-gutter bmw-md-results-content-service-bulletins-padding">
              <div class="col-sm-2 bmw-no-gutter">
                <i class="material-icons dp48" style="color:#b2aa8e;font-size:20px;">fiber_new</i>
              </div>
              <div class="col-sm-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'>
              </div>
            </div>
            <div class="col-sm-6 bmw-no-gutter bmw-md-results-content-service-bulletins-padding" [innerHTML]='bulletin.description | highlightSearch : searchKey'>
            </div>
            <div class="col-sm-2 bmw-no-gutter">
              <div *ngFor="let model of bulletin.series">
                <div class="col-sm-1 bmw-md-results-content-service-bulletins-model bmw-align-text-left" [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
              </div>
            </div>
            <div class="col-sm-2 bmw-no-gutter bmw-md-results-content-service-bulletins-padding bmw-align-text-left" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'>
            </div>
          </a>
        </div>
      </div>
    </div>
    
    <div *ngIf="search_section==='td'">
      <div class="bmw-sm-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-sm-results-content-service-bulletins-header ">Technical Documentation</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a [href]='"tech_documents/"+techDoc.documentFileName' target="_blank" style="cursor:pointer;margin-top:10px" class="row bmw-no-gutter bmw-md-results-content-service-bulletins-bulletin"
            *ngFor="let techDoc of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-sm-11 bmw-no-gutter bmw-md-results-content-service-bulletins-padding" style="padding-left:21px" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
            </div>
            <div class="col-sm-1 bmw-no-gutter bmw-align-text-right">
              <i class="material-icons dp48 bmw-sm-material-icon" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="tm"'>
      <div class="bmw-sm-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-sm-results-content-service-bulletins-header ">Technical Training Manuals</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a [href]='"tech_training_manuals/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter bmw-sm-results-content-tech-doc"
            *ngFor="let manual of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-sm-4 bmw-no-gutter " [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
            <div class="col-sm-6 bmw-no-gutter " [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
            <div class="col-sm-2 bmw-align-text-right bmw-no-gutter ">
              <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
            </div>
          </a>
        </div>
      </div>
      <div class="bmw-xs-section-seperator"></div>
      <div class="bmw-sm-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-sm-results-content-service-bulletins-header ">Body & Paint Manuals</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceCoError?.length > 0">{{serviceCoError}}</div>
          <div class="row bmw-no-gutter bmw-sm-results-content-tech-doc" *ngFor="let manual of bulletinCoSectionApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <a [href]='"body_and_paint/"+manual.documentFileName' target="_blank">
              <div class="col-xs-4 bmw-no-gutter " [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
              <div class="col-xs-6 bmw-no-gutter " [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-xs-2 bmw-align-text-right bmw-no-gutter ">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="faq"'>
      <div class="bmw-sm-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-sm-results-content-service-bulletins-header ">Top Links</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a [href]='"faq_top_links/"+techDoc.documentFileName' target="_blank" class="row bmw-no-gutter " *ngFor="let techDoc of bulletinApiData">
            <div class="col-sm-8 bmw-lg-results-content-tech-doc">
              <div class="col-sm-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
              </div>
              <div class="col-sm-2 bmw-no-gutter bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="bmw-xs-section-seperator"></div>
      <div class="bmw-sm-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-sm-results-content-service-bulletins-header ">FAQs</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a [href]='"faq_top_links/"+techDoc.documentFileName' target="_blank" class="row bmw-no-gutter " *ngFor="let techDoc of bulletinCoSectionApiData">
            <div class="col-sm-8 bmw-lg-results-content-tech-doc">
              <div class="col-sm-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
              </div>
              <div class="col-sm-2 bmw-no-gutter bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf="search_section==='obd'">
      <div class="bmw-sm-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-sm-results-content-service-bulletins-header ">OBD</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a [href]='"mount/obd/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter bmw-md-results-content-service-bulletins-bulletin"
            *ngFor="let manual of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-sm-3 bmw-no-gutter bmw-md-results-content-service-bulletins-padding">
              <div class="col-sm-3 bmw-no-gutter bmw-align-text-left" *ngFor='let engine of manual.engines' [innerHTML]='engine.engineName | highlightSearch : searchKey'>
              </div>
            </div>
            <div class="col-sm-5" [innerHTML]='manual.engineFamily | highlightSearch : searchKey'></div>
            <div class="col-sm-2 bmw-md-results-content-service-bulletins-padding">
              <div class="bmw-no-gutter bmw-align-text-left" style="margin-right:3px;float:left" *ngFor='let model of manual.series' [innerHTML]='model.seriesName | highlightSearch: searchKey'></div>
            </div>
            <div class="col-sm-2 bmw-aligh-text-right bmw-md-results-content-service-bulletins-padding" [innerHTML]='manual.releaseDate | date: dateFormat'></div>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="te"'>
      <div class="bmw-sm-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-sm-results-content-service-bulletins-header ">Equipment Manuals</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <a [href]='"equipmentManual/"+manual.documentFileName' target="_blank" class="row bmw-no-gutter bmw-sm-results-content-tech-doc"
            *ngFor="let manual of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-sm-10 bmw-no-gutter " [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
            <div class="col-sm-2 bmw-align-text-right bmw-no-gutter ">
              <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
            </div>
          </a>
        </div>
      </div>
      <div class="bmw-xs-section-seperator"></div>
      <div class="bmw-sm-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-sm-results-content-service-bulletins-header ">Tools</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceCoError?.length > 0">{{serviceCoError}}</div>
          <div [routerLink]='["/report-detail", report?.id]' class="row bmw-no-gutter bmw-sm-results-content-tech-doc" *ngFor="let report of bulletinCoSectionApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="col-sm-3 bmw-no-gutter bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.orderPartNumberId | highlightSearch: searchKey'>
            </div>
            <div class="col-sm-6 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.description | highlightSearch : searchKey'>
            </div>
            <div class="col-sm-2 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding">
              <div *ngFor="let model of report.series">
                <div class="bmw-no-gutter bmw-lg-results-content-service-bulletins-model bmw-align-text-left" style="margin-right:3px;float:left"
                  [innerHTML]='model.seriesName | highlightSearch : searchKey'></div>
              </div>
            </div>
            <div class="col-sm-1 bmw-no-gutter bmw-lg-results-content-service-bulletins-padding" [innerHTML]='report.bulletinId | highlightSearch : searchKey'>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- HTML5 for mobile -->

<div *ngIf='screenWidth > 319 && screenWidth < 767'>

  <div (window:orientationchange)="screenRotate($event)">
    <div *ngIf='search_section==="all"'>
      <div class="alert alert-danger" *ngIf='apiCheck === 0'>No matching results</div>
      <div>
        <div *ngIf='bulletinApiDataObject["Service Bulletins"]?.length > 0'>
          <div class="bmw-xs-results-content-service-bulletins">
            <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Service Bulletins</div>
            <div class="pointer" [routerLink]="['/bulletin', bulletin.bulletinDisplayId]" [queryParams]='{type: "sib"}' *ngFor="let bulletin of bulletinApiDataObject['Service Bulletins'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <div class="bmw-xs-bulletin-related-service-bulletins">
                <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-id-description">
                  <div class="row bmw-no-gutter">
                    <div class="col-xs-6 bmw-no-gutter" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'></div>
                    <div class="col-xs-6 bmw-align-text-right bmw-no-gutter" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'></div>
                  </div>
                  <div class="row bmw-no-gutter" [innerHTML]='bulletin.description | highlightSearch : searchKey'></div>
                </div>
                <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-models">
                  <div class="col-xs-9 bmw-no-gutter">
                    <div style="margin-right:3px;float:left" *ngFor="let model of bulletin.series" [innerHTML]='model.seriesName | highlightSearch : searchKey'>
                    </div>
                  </div>
                  <div class="col-xs-3 bmw-no-gutter bmw-align-text-right">
                    <a href="#">+6</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-xs-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a [routerLink]="['/results', 'sib']" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Service Bulletins</a>
          </div>
        </div>


        

        <div *ngIf='bulletinApiDataObject["Parts Bulletins"]?.length > 0'>
          <div class="bmw-xs-results-content-service-bulletins">
            <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Parts Bulletins</div>
            <div class="pointer" *ngFor="let bulletin of bulletinApiDataObject['Parts Bulletins'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a target="_blank" [href]='"parts_bulletin/"+bulletin.attachments[0]?.fileName'>
                <div class="bmw-xs-bulletin-related-service-bulletins">
                  <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-id-description">
                    <div class="row bmw-no-gutter">
                      <div class="col-xs-6 bmw-no-gutter" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'></div>
                      <div class="col-xs-6 bmw-align-text-right bmw-no-gutter" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'></div>
                    </div>
                    <div class="row bmw-no-gutter" [innerHTML]='bulletin.description | highlightSearch : searchKey'></div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-xs-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("pbs")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Parts Bulletins</a>
          </div>
        </div>
        <div *ngIf='bulletinApiDataObject["Technical Training Manuals"]?.length > 0'>
          <div class="bmw-xs-results-content-service-bulletins">
            <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Technical Training Manuals</div>
            <div class="row bmw-no-gutter bmw-xs-results-content-tech-doc" *ngFor="let manual of bulletinApiDataObject['Technical Training Manuals']  | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a [href]='"tech_training_manuals/"+manual.documentFileName' target="_blank">
                <div class="col-xs-4 bmw-no-gutter " [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
                <div class="col-xs-6 bmw-no-gutter " [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                <div class="col-xs-2 bmw-align-text-right bmw-no-gutter ">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-xs-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("tm")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Technical Training Manuals</a>
          </div>
        </div>


        <div *ngIf='bulletinApiDataObject["Body & Paint Manuals"]?.length > 0'>
          <div class="bmw-xs-results-content-service-bulletins">
            <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Body & Paint Manuals</div>
            <div class="row bmw-no-gutter bmw-xs-results-content-tech-doc" *ngFor="let manual of bulletinApiDataObject['Body & Paint Manuals'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a [href]='"body_and_paint/"+manual.documentFileName' target="_blank">
                <div class="col-xs-4 bmw-no-gutter " [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
                <div class="col-xs-6 bmw-no-gutter " [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                <div class="col-xs-2 bmw-align-text-right bmw-no-gutter ">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-xs-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("tm")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Body & Paint Manuals</a>
          </div>
        </div>
        <div *ngIf='bulletinApiDataObject["Onboard Diagnostic (OBD)"]?.length > 0'>
          <div class="bmw-xs-results-content-service-bulletins">
            <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Onboard Diagnostic (OBD)</div>
            <div class="pointer" *ngFor="let bulletin of bulletinApiDataObject['Onboard Diagnostic (OBD)'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a [href]='"mount/obd/"+bulletin.documentFileName' target="_blank">
                <div class="bmw-xs-bulletin-related-service-bulletins">
                  <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-id-description">
                    <div class="row bmw-no-gutter">
                      <div class="col-xs-8 bmw-no-gutter">
                        <div class="col-xs-3 bmw-no-gutter" *ngFor='let type of bulletin.engineTypes' [innerHTML]='type.engineName | highlightSearch : searchKey'>
                        </div>
                      </div>
                      <div class="col-xs-4 bmw-align-text-right bmw-no-gutter" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'></div>
                    </div>
                    <div class="row bmw-no-gutter" [innerHTML]='bulletin.engineFamily | highlightSearch : searchKey'></div>
                  </div>
                  <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-models">
                    <div class="col-xs-9 bmw-no-gutter">
                      <div class="col-xs-2 bmw-no-gutter" *ngFor="let model of bulletin.series" [innerHTML]='model.seriesName | highlightSearch : searchKey'>
                      </div>
                    </div>
                    <div class="col-xs-3 bmw-no-gutter bmw-align-text-right">
                      <a href="#">+6</a>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-xs-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("obd")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Onboard Diagnostic (OBD)</a>
          </div>
        </div>


        <div *ngIf='bulletinApiDataObject["Equipment Manuals"]?.length > 0'>
          <div class="bmw-xs-results-content-service-bulletins">
            <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Equipment Manuals</div>
            <div class="row bmw-no-gutter bmw-xs-results-content-tech-doc" *ngFor="let manual of contentType.content">
              <a [href]='"equipmentManual/"+manual.documentFileName' target="_blank">
                <div class="col-xs-10 bmw-no-gutter " [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
                <div class="col-xs-2 bmw-align-text-right bmw-no-gutter ">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-xs-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("te")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Equipment Manuals</a>
          </div>
        </div>


        <div *ngIf='bulletinApiDataObject["Tools Report"]?.length > 0'>
          <div class="bmw-xs-results-content-service-bulletins">
            <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Tools Report</div>
            <div [routerLink]='["/report-detail", report?.id]' *ngFor="let report of bulletinApiDataObject['Tools Report'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <div class="bmw-xs-bulletin-related-service-bulletins">
                <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-id-description">
                  <div class="row bmw-no-gutter">
                    <div class="col-xs-6 bmw-no-gutter" [innerHTML]='report.orderPartNumberId | highlightSearch : searchKey'></div>
                    <div class="col-xs-6 bmw-align-text-right bmw-no-gutter" [innerHTML]='report.bulletinId | highlightSearch : searchKey'></div>
                  </div>
                  <div class="row bmw-no-gutter" [innerHTML]='report.description | highlightSearch : searchKey'></div>
                </div>
                <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-models">
                  <div class="col-xs-9 bmw-no-gutter">
                    <div class="col-xs-2 bmw-no-gutter" *ngFor="let model of report.series" [innerHTML]='model.seriesName | highlightSearch : searchKey'>
                    </div>
                  </div>
                  <div class="col-xs-3 bmw-no-gutter bmw-align-text-right">
                    <a href="#">+6</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-xs-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("te")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Tools Report</a>
          </div>
        </div>


        <div *ngIf='bulletinApiDataObject["Technical Documentation"]?.length > 0'>
          <div class="bmw-xs-results-content-service-bulletins">
            <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Technical Documentation</div>
            <div class="row bmw-no-gutter bmw-xs-results-content-tech-doc" *ngFor="let techDoc of bulletinApiDataObject['Technical Documentation'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a [href]='"tech_training_manuals/"+techDoc.documentFileName' target="_blank">
                <div class="col-xs-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
                </div>
                <div class="col-xs-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-xs-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("td")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Technical Documentation</a>
          </div>
        </div>

        <div *ngIf='bulletinApiDataObject["Top Links"]?.length > 0'>
          <div class="bmw-xs-results-content-service-bulletins">
            <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Top Links</div>
            <div class="row bmw-no-gutter bmw-xs-results-content-tech-doc" *ngFor="let techDoc of bulletinApiDataObject['Top Links'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a [href]='"faq_top_links/"+techDoc.documentFileName' target="_blank">
                <div class="col-xs-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
                </div>
                <div class="col-xs-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-xs-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("faq")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more Top Links</a>
          </div>
        </div>

        <div *ngIf='contentType.title === "FAQs"  && contentType.content.length > 0'>
          <div class="bmw-xs-results-content-service-bulletins">
            <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">FAQs</div>
            <div class="row bmw-no-gutter bmw-xs-results-content-tech-doc" *ngFor="let techDoc of bulletinApiDataObject['FAQs'] | filterResults: filter | sortResults: sortBy | limitResults: limit">
              <a [href]='"faq_top_links/"+techDoc.documentFileName' target="_blank">
                <div class="col-xs-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
                </div>
                <div class="col-xs-2 bmw-no-gutter bmw-align-text-right">
                  <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
                </div>
              </a>
            </div>
          </div>
          <div class="row bmw-no-gutter bmw-xs-results-content-see-more-row">
            <i class="material-icons dp48 bmw-results-content-see-more-arrow" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>arrow_forward</i>
            <a (click)='navigateToSection("faq")' [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="bmw-results-content-see-more-anchor pointer">See more FAQs</a>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="sib"'>
      <div class="bmw-xs-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Service Bulletins</div>
        <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
        <div class="pointer" [routerLink]="['/bulletin', bulletin.bulletinDisplayId]" [queryParams]='{type: "sib"}' *ngFor="let bulletin of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
          <div class="bmw-xs-bulletin-related-service-bulletins">
            <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-id-description">
              <div class="row bmw-no-gutter">
                <div class="col-xs-6 bmw-no-gutter" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'></div>
                <div class="col-xs-6 bmw-align-text-right bmw-no-gutter" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'></div>
              </div>
              <div class="row bmw-no-gutter" [innerHTML]='bulletin.description | highlightSearch : searchKey'></div>
            </div>
            <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-models">
              <div class="col-xs-9 bmw-no-gutter">
                <div class="col-xs-2 bmw-no-gutter" *ngFor="let model of bulletin.series" [innerHTML]='model.seriesName | highlightSearch : searchKey'>
                </div>
              </div>
              <div class="col-xs-3 bmw-no-gutter bmw-align-text-right">
                <a href="#">+6</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div *ngIf='search_section==="pbs"'>
      <div class="bmw-xs-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Parts Bulletins</div>
        <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
        <div *ngFor="let bulletin of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
          <a target="_blank" [href]='"parts_bulletin/"+bulletin.attachments[0]?.fileName'>
            <div class="bmw-xs-bulletin-related-service-bulletins">
              <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-id-description">
                <div class="row bmw-no-gutter">
                  <div class="col-xs-6 bmw-no-gutter" [innerHTML]='bulletin.bulletinDisplayNumber | highlightSearch : searchKey'></div>
                  <div class="col-xs-6 bmw-align-text-right bmw-no-gutter" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'></div>
                </div>
                <div class="row bmw-no-gutter" [innerHTML]='bulletin.description | highlightSearch : searchKey'></div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="td"'>
      <div class="bmw-xs-results-content">
        <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Technical Documentation</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <div class="row bmw-no-gutter bmw-xs-results-content-tech-doc" *ngFor="let techDoc of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <a [href]='"tech_documents/"+techDoc.documentFileName' target="_blank">
              <div class="col-xs-10 bmw-no-gutter bmw-align-text-left" [innerHTML]='techDoc.documentTitle | highlightSearch : searchKey'>
              </div>
              <div class="col-xs-2 bmw-no-gutter bmw-align-text-right">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="tm"'>
      <div class="bmw-xs-results-content">
        <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Technical Training Manuals</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <div class="row bmw-no-gutter bmw-xs-results-content-tech-doc" *ngFor="let manual of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <a [href]='"tech_training_manuals/"+manual.documentFileName' target="_blank">
              <div class="col-xs-4 bmw-no-gutter " [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
              <div class="col-xs-6 bmw-no-gutter " [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-xs-2 bmw-align-text-right bmw-no-gutter ">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="bmw-xs-section-seperator"></div>
      <div class="bmw-xs-results-content">
        <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Body & Paint Manuals</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceCoError?.length > 0">{{serviceCoError}}</div>
          <div class="row bmw-no-gutter bmw-xs-results-content-tech-doc" *ngFor="let manual of bulletinCoSectionApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <a [href]='"body_and_paint/"+manual.documentFileName' target="_blank">
              <div class="col-xs-4 bmw-no-gutter " [innerHTML]='manual.documentNumber | highlightSearch:searchKey'></div>
              <div class="col-xs-6 bmw-no-gutter " [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-xs-2 bmw-align-text-right bmw-no-gutter ">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="te"'>
      <div class="bmw-xs-results-content">
        <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Equipment Manuals</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
          <div class="row bmw-no-gutter bmw-xs-results-content-tech-doc" *ngFor="let manual of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <a [href]='"equipmentManual/"+manual.documentFileName' target="_blank">
              <div class="col-xs-10 bmw-no-gutter " [innerHTML]='manual.documentTitle | highlightSearch:searchKey'></div>
              <div class="col-xs-2 bmw-align-text-right bmw-no-gutter ">
                <i class="material-icons dp48" style="font-size:20px" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>picture_as_pdf</i>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="bmw-xs-section-seperator"></div>
      <div class="bmw-xs-results-content">
        <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">Tools</div>
        <div class="row bmw-no-gutter">
          <div class="alert alert-danger" *ngIf="serviceCoError?.length > 0">{{serviceCoError}}</div>
          <div [routerLink]='["/report-detail", report?.id]' *ngFor="let report of bulletinCoSectionApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
            <div class="bmw-xs-bulletin-related-service-bulletins">
              <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-id-description">
                <div class="row bmw-no-gutter">
                  <div class="col-xs-6 bmw-no-gutter" [innerHTML]='report.orderPartNumberId | highlightSearch : searchKey'></div>
                  <div class="col-xs-6 bmw-align-text-right bmw-no-gutter" [innerHTML]='report.bulletinId | highlightSearch : searchKey'></div>
                </div>
                <div class="row bmw-no-gutter" [innerHTML]='report.description | highlightSearch : searchKey'></div>
              </div>
              <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-models">
                <div class="col-xs-9 bmw-no-gutter">
                  <div class="col-xs-2 bmw-no-gutter" *ngFor="let model of report.series" [innerHTML]='model.seriesName | highlightSearch : searchKey'>
                  </div>
                </div>
                <div class="col-xs-3 bmw-no-gutter bmw-align-text-right">
                  <a href="#">+6</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf='search_section==="obd"'>
      <div class="bmw-xs-results-content-service-bulletins">
        <div class="row bmw-no-gutter bmw-xs-results-content-service-bulletins-header ">OBD</div>
        <div class="alert alert-danger" *ngIf="serviceError?.length > 0">{{serviceError}}</div>
        <div *ngFor="let bulletin of bulletinApiData | filterResults: filter | sortResults: sortBy | limitResults: limit">
          <a [href]='"mount/obd/"+bulletin.documentFileName' target="_blank">
            <div class="bmw-xs-bulletin-related-service-bulletins">
              <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-id-description">
                <div class="row bmw-no-gutter">
                  <div class="col-xs-8 bmw-no-gutter">
                    <div class="col-xs-3 bmw-no-gutter" *ngFor='let type of bulletin.engineTypes' [innerHTML]='type.engineName | highlightSearch : searchKey'>
                    </div>
                  </div>
                  <div class="col-xs-4 bmw-align-text-right bmw-no-gutter" [innerHTML]='bulletin.releaseDate | date: dateFormat | highlightSearch : searchKey'></div>
                </div>
                <div class="row bmw-no-gutter" [innerHTML]='bulletin.engineFamily | highlightSearch : searchKey'></div>
              </div>
              <div class="row bmw-no-gutter bmw-xs-bulletin-related-bulletins-models">
                <div class="col-xs-9 bmw-no-gutter">
                  <div class="col-xs-2 bmw-no-gutter" *ngFor="let model of bulletin.series" [innerHTML]='model.seriesName | highlightSearch : searchKey'>
                  </div>
                </div>
                <div class="col-xs-3 bmw-no-gutter bmw-align-text-right">
                  <a href="#">+6</a>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>